import { lazyWithRetry } from 'utils/lazyWithRetry'

export const Icon__Duplicate = lazyWithRetry(() =>
  import(/* webpackChunkName: "Icon__Duplicate" */ './Icon__Duplicate')
)
export const Icon__Video = lazyWithRetry(() =>
  import(/* webpackChunkName: "Icon__Video" */ './Icon__Video')
)
export const Icon__PDF = lazyWithRetry(() =>
  import(/* webpackChunkName: "Icon__PDF" */ './Icon__PDF')
)
export const Icon__Website = lazyWithRetry(() =>
  import(/* webpackChunkName: "Icon__Website" */ './Icon__Website')
)
export const Icon__Alert = lazyWithRetry(() =>
  import(/* webpackChunkName: "Icon__Alert" */ './Icon__Alert')
)
export const Icon__Cancel = lazyWithRetry(() =>
  import(/* webpackChunkName: "Icon__Cancel" */ './Icon__Cancel')
)
export const Icon__Swap = lazyWithRetry(() =>
  import(/* webpackChunkName: "Icon__Swap" */ './Icon__Swap')
)
export const Icon__HelpInput = lazyWithRetry(() =>
  import(/* webpackChunkName: "Icon__HelpInput" */ './Icon__HelpInput')
)
export const Icon__Info = lazyWithRetry(() =>
  import(/* webpackChunkName: "Icon__Info" */ './Icon__Info')
)
export const Icon__PinLocation = lazyWithRetry(() =>
  import(/* webpackChunkName: "Icon__PinLocation" */ './Icon__PinLocation')
)
export const Icon__SaveClose = lazyWithRetry(() =>
  import(/* webpackChunkName: "Icon__SaveClose" */ './Icon__SaveClose')
)
export const Icon__NewWindow = lazyWithRetry(() =>
  import(/* webpackChunkName: "Icon__NewWindow" */ './Icon__NewWindow')
)
export const Icon__Snapshot = lazyWithRetry(() =>
  import(/* webpackChunkName: "Icon__Snapshot" */ './Icon__Snapshot')
)
